import styled from 'styled-components';
import { BodyText, Button } from '../../../components/ui';
import { useNavigate } from 'react-router-dom';

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 1450px;
  gap: 1.5rem;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem 0 0 0;
  flex: 2.5;
  max-width: 1600px;
  min-height: 50vh;
  align-items: center;

  @media (max-width: 768px) {
    width: 95%;
    max-width: 95%;
    min-height: 40vh;
    margin-top: 1rem;
  }

  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
    min-height: 35vh;
    margin-top: 0.5rem;
  }
`;

const SideSection = styled.div`
  display: flex;
  flex: 0.6;
  min-width: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

const OrderNumberContainer = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
  padding: 1rem 0;
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.colors.subBackground};
  gap: 10px;

  @media (max-width: 768px) {
    width: 90%;
    margin: 1.5rem 0;
    padding: 0.8rem 0;
    gap: 8px;
  }

  @media (max-width: 480px) {
    width: 95%;
    margin: 1rem 0;
    padding: 0.5rem 0;
    gap: 5px;
  }
`;

const DetailLink = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.primaryBlue};
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

const CompleteView = ({ soNo }) => {
  const navigate = useNavigate();

  const handleContinue = async () => {
    // clear cart
    navigate('/');
  };

  return (
    <>
      <ContentWrapper>
        <MainContainer>
          <BodyText
            style={{
              textAlign: 'center',
              lineHeight: '1.6',
              maxWidth: '90%',
              marginBottom: '1rem',
            }}
          >
            A confirmation email has been sent to you. We will notify you once
            your order is ready. For any inquiries, please contact us at{' '}
            <a
              href='tel:+13232581717'
              style={{
                color: 'inherit',
                textDecoration: 'none',
                fontWeight: 'bold',
              }}
            >
              (323) 258-1717
            </a>{' '}
            or{' '}
            <a
              href='mailto:orders@edencorp.com'
              style={{
                color: 'inherit',
                textDecoration: 'none',
                fontWeight: 'bold',
              }}
            >
              orders@edencorp.com
            </a>
          </BodyText>
          <OrderNumberContainer>
            <BodyText
              weight={'bold'}
              color='black'
              size={'1.3rem'}
              style={{ textAlign: 'center' }}
            >
              {`Order number : ${soNo}`}
            </BodyText>
            <DetailLink href={`/#/order/${soNo}`}>
              Click here for order details.
            </DetailLink>
          </OrderNumberContainer>
          <Button onClick={handleContinue}>CONTINUE</Button>
        </MainContainer>
        <SideSection />
      </ContentWrapper>
    </>
  );
};

export default CompleteView;
